import {CatalogModel} from '../Model/CatalogModel';
import {CatalogEntity, CatalogEntityData} from '../Entity/CatalogEntity';
import {catalogPageMapper} from './CatalogPageMapper';
import {catalogTocMapper} from './CatalogTocMapper';
import {catalogCategoryMapper} from './CatalogCatagoryMapper';

export const catalogMapper = (data: CatalogModel): CatalogEntity => {
  const catalogEntityData: CatalogEntityData = {
    pages: [],
    categories: [],
    toc: []
  };

  data.pages.map(pageModel => {
    catalogEntityData.pages.push(catalogPageMapper(pageModel));
  });

  data.toc.map(tocModel => {
    catalogEntityData.toc.push(catalogTocMapper(tocModel));
  });

  data.categories.map(categoryModel => {
    catalogEntityData.categories.push(catalogCategoryMapper(categoryModel, catalogEntityData.toc));
  });

  return new CatalogEntity(catalogEntityData);
};
